"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("./styled"));

var _BottomSheet = _interopRequireDefault(require("../../../blocks/BottomSheet"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ConfirmationSheet = ({
  bodyText,
  bottom,
  buttons,
  visible
}) => {
  if (!visible) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_BottomSheet.default, {
    bottom: bottom,
    visible: visible
  }, /*#__PURE__*/_react.default.createElement(_styled.default.Wrapper, null, /*#__PURE__*/_react.default.createElement(_styled.default.BodyText, null, bodyText), /*#__PURE__*/_react.default.createElement(_styled.default.ActionWrap, null, buttons.map(data => /*#__PURE__*/_react.default.createElement(_BottomSheet.default.ActionButton, {
    modifiers: [data.type],
    onClick: data.clickHandler
  }, data.text)))));
};

ConfirmationSheet.propTypes = {
  bodyText: _propTypes.default.string.isRequired,
  bottom: _propTypes.default.number,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    clickHandler: _propTypes.default.func.isRequired,
    type: _propTypes.default.oneOf(['success', 'plain', 'primary', 'danger'])
  })).isRequired,
  visible: _propTypes.default.bool.isRequired
};
ConfirmationSheet.defaultProps = {
  bottom: 40
};
var _default = ConfirmationSheet;
exports.default = _default;